import { Component, input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'lib-logo-with-badge',
  imports: [],
  template: `
    <div class="logo-wrapper">
      <img
        [src]="src()"
        [alt]="alt()"
        [class]="logoClass()"
      />
      @if (showDevBadge()) {
        <span class="dev-badge">DEV</span>
      }
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.Eager,
  styles: [`
    .logo-wrapper {
      display: inline-flex;
      align-items: center;
      gap: 0.5rem;
    }

    .dev-badge {
      background: #1e3a5f;
      color: white;
      font-size: 0.6rem;
      font-weight: 600;
      padding: 0.2rem 0.5rem;
      border-radius: 4px;
    }
  `]
})
export class LogoWithBadgeComponent {
  src = input.required<string>();
  alt = input<string>('AWO Care Logo');
  logoClass = input<string>('');
  tier = input<string>('PROD');

  showDevBadge = () => {
    const envTier = this.tier();
    return envTier === 'DEV' || envTier === 'LOCAL';
  };
}
